module.exports = __webpack_public_path__ + "edd7c0210afb8f309b5d2894a090a1aa-811_2_2x.png";


//////////////////
// WEBPACK FOOTER
// ./src/components/pages/eightOneOne/assets/811_2_2x.png
// module id = 615
// module chunks = 0